module.exports = __webpack_public_path__ + "static/bar04_2_mobile-11f54f3c512dabe122a57642eeabe14b.png";